<button class="cerrarButton" (click)="cerrar()">+</button>

<h2>Resultado de la Evaluación</h2>

<mat-dialog-content>
    <p>En esta pantalla podrá visualiazar todas las preguntas de su prueba y las respuestas que usted seleccionó; 
        en caso de que su respuesta haya sido incorrecta, encontrará la explicación técnica asociada.</p>

    <table class="table-info">
        <tr>
            <td>Estado:</td>
            <td>Finalizada</td>
        </tr>
        <tr>
            <td>Puntos:</td>
            <td>{{evaluacion.correctas}}</td>
        </tr>
        <tr>
            <td>Porcentaje de logro:</td>
            <td>{{evaluacion.porcentaje}}%</td>
        </tr>
    </table>
    <mat-divider></mat-divider>
    <table class="table-respuestas" *ngFor="let pregunta of evaluacion.evaluacion; let i = index">
        <tr>
            <th>
                <h1>Pregunta {{i+1}}</h1>
                <p class="estadoPregunta estado-correcta" *ngIf="pregunta.correcta">Correcta</p>
                <p class="estadoPregunta estado-incorrecta" *ngIf="!pregunta.correcta">Incorrecta</p>
            </th>
            <th>
                <p class="pregunta" [innerHTML]="pregunta.pregunta"></p>
            </th>
        </tr>
        <tr>
            <td></td>
            <td>
                <mat-radio-group required
                    aria-labelledby="example-radio-group-label"
                    class="example-radio-group">
                    <mat-radio-button class="example-radio-button" [disabled]="true" 
                    [ngClass]=" 
                        {'estado-correcta':alternativa.seleccionada && alternativa.correcta,
                        'estado-incorrecta': alternativa.seleccionada && !alternativa.correcta}"
                    *ngFor="let alternativa of pregunta.alternativas; let a = index" [value]="alternativa.idAlternativa" [checked]="alternativa.seleccionada">
                    {{alternativa.mensaje}}
                    </mat-radio-button>
                </mat-radio-group>
            </td>
        </tr>
        <tr *ngIf="!pregunta.correcta">
            <td></td>
            <td class="respuesta-incorrecta">
                <ng-container *ngFor="let alternativa of pregunta.alternativas;">
                    <ng-container *ngIf="alternativa.correcta">
                        <b>Respuesta correcta: </b> <label class="estado-correccion"> {{alternativa.mensaje}}</label>
                    </ng-container>
                </ng-container>                
            </td>
        </tr>
    </table>


    <h2>Resumen de intentos previos</h2>
    <table class="table-resumenIntentos">
        <tr>
            <th>Intento</th>
            <th>Estado</th>
            <th>Puntos / 16</th>
            <th>Porcentaje de logro / 100%</th>
        </tr>
        <tr *ngFor="let intento of evaluacion.intentos">
            <td>{{intento.intento}}</td>
            <td>Finalizada</td>
            <td>{{intento.correctas}}</td>
            <td>{{intento.porcentaje}}%</td>
        </tr>
        <tr>
            <td>{{evaluacion.intentos.length + 1}}</td>
            <td>Finalizada</td>
            <td>{{evaluacion.correctas}}</td>
            <td>{{evaluacion.porcentaje}}%</td>
        </tr>
    </table>

</mat-dialog-content>
